import React from 'react'
import { Navigate } from 'react-router-dom'
import { useUserInfo } from '../components/Authentication/hooks/useUserInfo'

function ProtectedRoute({ children }) {
  const { isSignedIn, isLoading } = useUserInfo()

  // While auth status is loading, render nothing to avoid flashing content
  if (isLoading) {
    return null
  }

  // If user is not authenticated, redirect to auth page
  if (!isSignedIn) {
    return <Navigate to="/auth" replace />
  }

  return children
}

export default ProtectedRoute
